


// export const base_url = 'https://dream.piciip.integratorsx.com';
export const base_url = 'https://api.dreams.piciip.gop.pk';



export const formatDateTimetoDateStr = (datestr) => {
    if(!datestr) {
        return '';
    }


    return (`${datestr.slice(8,10)}-${datestr.slice(5,7)}-${datestr.slice(0,4)}`)
}


export const getToday = () => {
  const date = new Date();
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth()+1).toString().padStart(2, '0')

  return `${date.getFullYear()}-${month}-${day}`
}



export const getRelativePath = (path) => {
    if (!path){
        return '';
    }
    const index = path.indexOf("\\MediaGallery");
    const extractedPath = path.substring(index);
    const encodedPath = extractedPath.replaceAll(' ', '%20');
    const relativePath = encodedPath.replaceAll('\\', '/');
    return `${base_url}${relativePath}`;
}


export const updateImageUrlsMEI = (description) => {
    if (!description) return description;
    
    // Regular expression to find both src and href attributes
    // const pattern = /(?<=src="|href=")\/media\/uploads\/[^"]+/g;
    const pattern = /(?<=src="|href=")\/MediaGallery\/[^"]+/g;

    
    // Replace src and href attributes with the full URL
    const updatedDescription = description.replace(pattern, (relativeUrl) => {
        const fullUrl = `${base_url}${relativeUrl}`;
        return fullUrl; // Return the full URL
    });

    console.log(updatedDescription, 'updatedDescription')
    
    return updatedDescription;
}